/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateScreenerBedUnitRankRequest
 */
export interface UpdateScreenerBedUnitRankRequest {
    /**
     * The facility the bed unit belongs to
     */
    facility_id: string;
    /**
     * The current rank of the bed unit
     */
    current_rank: number;
    /**
     * The new rank to assign to the bed unit
     */
    new_rank: number;
}

/**
 * Check if a given object implements the UpdateScreenerBedUnitRankRequest interface.
 */
export function instanceOfUpdateScreenerBedUnitRankRequest(value: object): value is UpdateScreenerBedUnitRankRequest {
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('current_rank' in value) || value['current_rank'] === undefined) return false;
    if (!('new_rank' in value) || value['new_rank'] === undefined) return false;
    return true;
}

export function UpdateScreenerBedUnitRankRequestFromJSON(json: any): UpdateScreenerBedUnitRankRequest {
    return UpdateScreenerBedUnitRankRequestFromJSONTyped(json, false);
}

export function UpdateScreenerBedUnitRankRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateScreenerBedUnitRankRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_id': json['facility_id'],
        'current_rank': json['current_rank'],
        'new_rank': json['new_rank'],
    };
}

export function UpdateScreenerBedUnitRankRequestToJSON(json: any): UpdateScreenerBedUnitRankRequest {
    return UpdateScreenerBedUnitRankRequestToJSONTyped(json, false);
}

export function UpdateScreenerBedUnitRankRequestToJSONTyped(value?: UpdateScreenerBedUnitRankRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_id': value['facility_id'],
        'current_rank': value['current_rank'],
        'new_rank': value['new_rank'],
    };
}

